import src from "IMAGE";
export default { src, width: 90, height: 85, blurWidth: 0, blurHeight: 0};
